import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InformationCircleIcon, ExclamationCircleIcon as OExclamationIcon, MegaphoneIcon, PencilSquareIcon, ArrowRightCircleIcon, LightBulbIcon, } from '@heroicons/react/24/outline';
import { ExclamationTriangleIcon as SExclamationIcon, ExclamationCircleIcon as SExclamationCircleIcon, XCircleIcon, BoltIcon, ChevronRightIcon, } from '@heroicons/react/24/solid';
import classNames from 'classnames';
import { MyST } from './MyST.js';
// import { AdmonitionKind } from 'myst-common';
// TODO: get this from myst-spec?
export var AdmonitionKind;
(function (AdmonitionKind) {
    AdmonitionKind["admonition"] = "admonition";
    AdmonitionKind["attention"] = "attention";
    AdmonitionKind["caution"] = "caution";
    AdmonitionKind["danger"] = "danger";
    AdmonitionKind["error"] = "error";
    AdmonitionKind["important"] = "important";
    AdmonitionKind["hint"] = "hint";
    AdmonitionKind["note"] = "note";
    AdmonitionKind["seealso"] = "seealso";
    AdmonitionKind["tip"] = "tip";
    AdmonitionKind["warning"] = "warning";
})(AdmonitionKind || (AdmonitionKind = {}));
function getClasses(className) {
    var _a;
    const classes = (_a = className === null || className === void 0 ? void 0 : className.split(' ').map((s) => s.trim().toLowerCase()).filter((s) => !!s)) !== null && _a !== void 0 ? _a : [];
    return [...new Set(classes)];
}
function getFirstKind({ kind, classes = [], }) {
    if (kind === AdmonitionKind.note || classes.includes('note')) {
        return { kind: AdmonitionKind.note, color: 'blue' };
    }
    if (kind === AdmonitionKind.important || classes.includes('important')) {
        return { kind: AdmonitionKind.important, color: 'blue' };
    }
    if (kind === AdmonitionKind.hint || classes.includes('hint')) {
        return { kind: AdmonitionKind.hint, color: 'green' };
    }
    if (kind === AdmonitionKind.seealso || classes.includes('seealso')) {
        return { kind: AdmonitionKind.seealso, color: 'green' };
    }
    if (kind === AdmonitionKind.tip || classes.includes('tip')) {
        return { kind: AdmonitionKind.tip, color: 'green' };
    }
    if (kind === AdmonitionKind.attention || classes.includes('attention')) {
        return { kind: AdmonitionKind.attention, color: 'yellow' };
    }
    if (kind === AdmonitionKind.warning || classes.includes('warning')) {
        return { kind: AdmonitionKind.warning, color: 'yellow' };
    }
    if (kind === AdmonitionKind.caution || classes.includes('caution')) {
        return { kind: AdmonitionKind.caution, color: 'yellow' };
    }
    if (kind === AdmonitionKind.danger || classes.includes('danger')) {
        return { kind: AdmonitionKind.danger, color: 'red' };
    }
    if (kind === AdmonitionKind.error || classes.includes('error')) {
        return { kind: AdmonitionKind.error, color: 'red' };
    }
    return { kind: AdmonitionKind.note, color: 'blue' };
}
const iconClass = 'inline-block pl-2 mr-2 self-center flex-none';
function AdmonitionIcon({ kind, className }) {
    const cn = classNames(iconClass, className);
    const opts = { width: '2rem', height: '2rem', className: cn };
    if (kind === AdmonitionKind.note)
        return _jsx(InformationCircleIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.caution)
        return _jsx(OExclamationIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.warning)
        return _jsx(SExclamationIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.danger)
        return _jsx(SExclamationCircleIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.error)
        return _jsx(XCircleIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.attention)
        return _jsx(MegaphoneIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.tip)
        return _jsx(PencilSquareIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.hint)
        return _jsx(LightBulbIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.important)
        return _jsx(BoltIcon, Object.assign({}, opts));
    if (kind === AdmonitionKind.seealso)
        return _jsx(ArrowRightCircleIcon, Object.assign({}, opts));
    return _jsx(InformationCircleIcon, Object.assign({}, opts));
}
export const AdmonitionTitle = ({ node }) => {
    return _jsx(MyST, { ast: node.children });
};
const WrapperElement = ({ dropdown, className, children, }) => {
    if (dropdown)
        return _jsx("details", { className: className, children: children });
    return _jsx("aside", { className: className, children: children });
};
const HeaderElement = ({ dropdown, className, children, }) => {
    if (dropdown)
        return _jsx("summary", { className: className, children: children });
    return _jsx("div", { className: className, children: children });
};
export function Admonition({ title, kind, color, simple, dropdown, children, hideIcon, className, }) {
    return (_jsxs(WrapperElement, { dropdown: dropdown, className: classNames('my-5 shadow-md dark:shadow-2xl dark:shadow-neutral-900', 'bg-gray-50/10 dark:bg-stone-800', 'overflow-hidden', {
            'rounded border-l-4': !simple,
            'border-l-2': simple,
            'border-blue-500': !color || color === 'blue',
            'border-green-600': color === 'green',
            'border-amber-600': color === 'yellow',
            'border-red-600': color === 'red',
        }, className), children: [title && (_jsxs(HeaderElement, { dropdown: dropdown, className: classNames('m-0 font-medium py-1 flex min-w-0', {
                    'text-lg': !simple,
                    'text-md': simple,
                    'bg-gray-100 dark:bg-stone-700': simple,
                    'text-blue-600 bg-blue-50 dark:bg-slate-900': !simple && (!color || color === 'blue'),
                    'text-green-600 bg-green-50 dark:bg-slate-900': !simple && color === 'green',
                    'text-amber-600 bg-amber-50 dark:bg-slate-900': !simple && color === 'yellow',
                    'text-red-600 bg-red-50 dark:bg-slate-900': !simple && color === 'red',
                    'cursor-pointer hover:shadow-[inset_0_0_0px_30px_#00000003] dark:hover:shadow-[inset_0_0_0px_30px_#FFFFFF03]': dropdown,
                }), children: [!hideIcon && (_jsx(AdmonitionIcon, { kind: kind !== null && kind !== void 0 ? kind : AdmonitionKind.note, className: classNames({
                            // Needed for simple!
                            'text-blue-600': !color || color === 'blue',
                            'text-green-600': color === 'green',
                            'text-amber-600': color === 'yellow',
                            'text-red-600': color === 'red',
                        }) })), _jsx("div", { className: classNames('text-neutral-900 dark:text-white grow self-center overflow-hidden break-words', { 'ml-4': hideIcon }), children: title }), dropdown && (_jsx("div", { className: "self-center flex-none text-sm font-thin text-neutral-700 dark:text-neutral-200", children: _jsx(ChevronRightIcon, { width: "2rem", height: "2rem", className: classNames(iconClass, 'transition-transform details-toggle') }) }))] })), _jsx("div", { className: classNames('px-4', { 'py-1': !simple, 'details-body': dropdown }), children: children })] }));
}
export const AdmonitionRenderer = ({ node }) => {
    const [title, ...rest] = node.children;
    const classes = getClasses(node.class);
    const { kind, color } = getFirstKind({ kind: node.kind, classes });
    const isDropdown = classes.includes('dropdown');
    const isSimple = classes.includes('simple');
    const hideIcon = node.icon === false;
    const useTitle = (title === null || title === void 0 ? void 0 : title.type) === 'admonitionTitle';
    return (_jsx(Admonition, { title: useTitle ? _jsx(MyST, { ast: [title] }) : undefined, kind: kind, color: color, dropdown: isDropdown, simple: isSimple, hideIcon: hideIcon, className: classNames(classes), children: useTitle ? _jsx(MyST, { ast: rest }) : _jsx(MyST, { ast: node.children }) }));
};
const ADMONITION_RENDERERS = {
    admonition: AdmonitionRenderer,
    admonitionTitle: AdmonitionTitle,
};
export default ADMONITION_RENDERERS;
